<template>
<div>

  <div class="content content-boxed">
    <!-- Information du profile -->
    <div class="row">
      <div class="col-xs-12">


        <div class="block block-bordered">
          <div class="block block-themed">
            <div class="block-header bg-primary-dark">
                  <ul  class="block-options">
                      <li v-if="flagDisplayBanner===0">
                          <button type="button" @click="toggleDisplayBanner()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                      </li>
                      <li v-if="flagDisplayBanner">
                          <button  type="button" @click="toggleDisplayBanner()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                      </li>
                  </ul>
              <h2 class="block-title" @click="toggleDisplayBanner()"><i class="fa fa-bar-chart-o fa-1x push-5-r"></i>  {{labelTitleBanner[actualLanguage]}}</h2>
            </div>

            <div v-if="flagDisplayBanner" class="block-content">

              <div class="row">
                <div class="col-xs-12">
                    <!-- Unit Detail Information  -->
                    <div class="block">


                    <div class="col-xs-12 push">
                      <div class="col-xs-12 push">
                        <div class="col-xs-12 col-md-6 align-center">
                          <h5>{{labelButton[actualLanguage]}}</h5>
                        </div>
                        <div class="col-xs-12 col-md-6">
                          <label class="css-input switch switch-success">
                          <input type="checkbox" checked v-model="flagReadByInvoiceData">
                          <span></span>
                          <h5 v-if="flagReadByInvoiceData">{{lableActivated[actualLanguage]}}</h5>
                          <h5 v-else>{{lableNotActivated[actualLanguage]}}</h5>
                        </label>
                        </div>
                      </div>

                      <div class="col-xs-12 push">
                        <div class="col-xs-12 col-md-4">
                          <div class="input-daterange form-group row">
                              <div class="input-date-time-picker" >
                                <date-picker
                                    class="el-input__inner form-control"
                                    v-model="visualisationDateStart"
                                    type="date"
                                    placeholder=""
                                    clear-icon=""
                                    format="yyyy-MM-dd"
                                    value-format="timestamp"
                                />
                              </div>
                          </div>
                        </div>

                        <div class="col-xs-12 col-md-4">
                          <div class="input-daterange form-group row">
                              <div class="input-date-time-picker" >
                                <date-picker
                                    class="el-input__inner form-control"
                                    v-model="visualisationDateEnd"
                                    type="date"
                                    placeholder=""
                                    clear-icon=""
                                    format="yyyy-MM-dd"
                                    value-format="timestamp"
                                />
                              </div>
                          </div>
                        </div>

                        <div class="col-xs-12 col-md-4">
                            <button  type="button" @click="readUnitsGraphData()" class="btn btn-default align-right" name="buttonAddPlanItem">
                              <i class="fa fa-download fa-1x push-5-r "></i>{{ labelButtonReadGraph[actualLanguage] }}</button>
                        </div>
                      </div>



                      <div class="col-xs-12 push">
                        <div class="col-xs-12 col-md-12 align-center">
                          <h5>{{labelFiltreSection[actualLanguage]}}</h5>
                        </div>

                        <div class="col-xs-12 col-md-3 push">
                              <div class="form-group">
                                <h6 class="align-center">{{labelTagSelect[actualLanguage]}}</h6>
                                <div class="col-sm-12">
                                    <select class="form-control" @change="applyUnitFilter()" v-model=selectedTag size="1">
                                        <option value="All">Tous/All</option>
                                        <option v-for="type in tagsList" :value="type.tagId">{{type.tagName}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="col-xs-12 col-md-3 push">
                              <div class="form-group">
                                <h6 class="align-center">{{labelSpecType[actualLanguage]}}</h6>
                                <div class="col-sm-12">
                                  <select class="form-control" @change="applyUnitFilter()" v-model="selectedType" size="1">
                                      <option value="All">Tous/All</option>
                                      <option v-for="type in specTypeList" :value="type.list_id">{{type.description[actualLanguage]}}</option>
                                  </select>
                                </div>
                            </div>
                        </div>


                        <div class="col-xs-12 col-md-3 push">
                              <div class="form-group">
                                <h6 class="align-center">{{labelSpecArea[actualLanguage]}}</h6>
                                <div class="col-sm-12">
                                  <select class="form-control" @change="applyUnitFilter()" v-model="selectedArea" size="1">
                                      <option value="All">Tous/All</option>
                                      <option v-for="area in specAreaList" :value="area.list_id">{{area.description[actualLanguage]}}</option>
                                  </select>
                                </div>
                            </div>
                        </div>

                        <div class="col-xs-12 col-md-3 push">
                              <div class="form-group">
                                <h6 class="align-center">{{labelSpecYearOfConstruction[actualLanguage]}}</h6>
                                <div class="col-sm-12">
                                  <select class="form-control" @change="applyUnitFilter()" v-model="selectedYearOfConstruction" size="1">
                                      <option value="All">Tous/All</option>
                                      <option v-for="yearOfConstruct in specYearOfConstructList" :value="yearOfConstruct.list_id">{{yearOfConstruct.description[actualLanguage]}}</option>
                                  </select>
                                </div>
                            </div>
                        </div>

                      </div>

                    </div>




                        <div v-if="flagGraphDataIsUpdating" class="col-xs-12 col-md-12">
                          <spinner size="large"></spinner>
                        </div>

                        <div v-if="flagDisplayStatTable" class="col-xs-12 push">

                            <div v-if="flagDisplayGraph" class="col-xs-12 col-md-12 push">
                              <div class="col-xs-12 col-md-12">
                              <button  type="button" @click="flagDisplayGraph =false" class="btn btn-default align-right" name="buttonAddPlanItem">
                              <i class="fa fa-close fa-1x push-5-r "></i>{{ buttonCloseChart[actualLanguage] }}</button>
                              </div>
                              <div class="col-xs-12 col-md-12">
                              <apexchart type="bar" height="400" :options="unitGraphOptions" :series="chartDataSeries"></apexchart>
                              </div>  
                            </div>           


                            <div class="col-xs-12 col-md-12 align-center">
                              <span class="badge badge-success">
                              <h5 class="align-center">{{averageCost[actualLanguage]}}</h5>
                              <h1 class="align-center">{{averageCostValue}} $</h1>
                              </span>
                            </div>


                            <div class="col-xs-12 col-md-12">

                              <div class="table-responsive push">
                                  <table class="table table-striped table-vcenter">
                                      <thead>
                                          <tr>
                                              <th class="text-center" style="width: 15%;">{{statTableColumn01[actualLanguage]}}</th>
                                              <th class="text-center" style="width: 15%;">{{statTableColumn02[actualLanguage]}}</th>
                                              <th class="text-center" style="width: 15%;">{{statTableColumn03[actualLanguage]}}</th>
                                              <th class="text-center" style="width: 20%;">{{statTableColumn04[actualLanguage]}}</th>
                                              <th class="text-center" style="width: 15%;">{{statTableColumn05[actualLanguage]}}</th>
                                              <th class="text-center" style="width: 15%;">{{statTableColumn06[actualLanguage]}}</th>
                                              <th class="text-center" style="width: 5%;"></th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          <tr v-for= "(unit,index) in unitsDataFiltered">
                                              <td class="font-w600 text-center">
                                                {{unit.UnitName}}
                                              </td>
                                              <td class="font-w600 text-center">
                                                <p v-for= "(tag) in unit.tags" class="font-w600 push-10"><span class="badge badge-success">{{tag}}</span></p>
                                      
                                              </td>
                                              <td class="font-w600 text-center">
                                                <span class="badge badge-primary">{{unit.type}}</span>
                                                <span class="badge badge-primary">{{unit.area}}</span>
                                                <span class="badge badge-primary">{{unit.yoc}}</span>
                                              </td>                                              
                                              <td class="font-w600 text-center">
                                                {{unit.Occupant}}
                                              </td>
                                              <td class="font-w600 text-center">
                                                <h3 v-if="unit.CostVsAverage>125" class="align-center">{{unit.SumCost}} $</h3>
                                                <h5 v-else class="align-center">{{unit.SumCost}} $</h5>
                                              </td>
                                              <td class="font-w600 text-center">
                                                <h3 v-if="unit.CostVsAverage>125" class="align-center">{{unit.CostVsAverage}} %</h3>
                                                <h5 v-else class="align-center">{{unit.CostVsAverage}} %</h5>
                                                
                                              </td>
                                              <td class="font-w600 text-center">
                                              <div class="btn-group">
                                                  <button class="btn btn-default" type="button" data-toggle="tooltip"
                                                  @click="displayUnitGraph(index)" title="Supprimer/Delete"><i class="fa fa-bar-chart"></i></button>
                                              </div>
                                              </td>                                                
                                          </tr>

                                      </tbody>
                                  </table>

                              </div>
                            </div>


                        </div>

                    </div>




                    <!-- END Static Labels -->
                    </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>


<script>

import Spinner from '@/components/Spinner'
import Vue from 'vue'
import {mapState, mapActions, mapGetters} from 'vuex'
import { DatePicker, TimePicker, TimeSelect } from 'element-ui';
import moment from 'moment';

//https://apexcharts.com/docs/vue-charts/
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

export default {
  name: 'UnitStats',
  props: ['unitList'],
 
  data() {
    return {
      flagDisplayBanner : 0,
      flagDisplayDetail : 0,
      profileIsSaving : false,
      unitIsSaving : false,
      actualLanguage : "FR",
      labelTitleBanner: {FR: "Statistiques d'unités", EN: 'Units statistics'},

      flagReadByInvoiceData : false,
      labelButton: {FR: "Données selon les saisies de factures",
                    EN: 'Read data according to billing data'},
      lableActivated :  {FR: "Activé", EN: 'Enabled'},
      lableNotActivated :  {FR: "Désactivé", EN: 'Disabled'},


      visualisationDateStart : '',
      visualisationDateEnd : '',
      labelButtonReadGraph: {FR: "Lire les données", EN: 'Read data'},
      

      labelFiltreSection: {FR: "Filtre", EN: 'Filter'},
      labelTagSelect: {FR: "Étiquette", EN: 'Tag'},
      selectedTag : 'All',
      selectedType : 'All',
      selectedArea : 'All',
      selectedYearOfConstruction : 'All',
      labelSpecType : {FR: "Type d'unité",
                        EN: 'Unit type'},
      labelSpecArea : {FR: "Superficie de l'unité",
                        EN: 'Unit area'},
      labelSpecYearOfConstruction : {FR: "Année de construction",
                                      EN: 'Year of construction)'},


      specAreaList : [],
      specTypeList:[],
      specYearOfConstructList : [],
      tagsList : [],

      unitFilterFlagList : [],
      unitListID : [],
      unitData : [],

      flagDisplayGraph : false,
      flagDisplayStatTable : false,
      flagGraphDataIsUpdating : false,
      unitsData : [],
      unitsDataFiltered : [],
      averageCost : {FR: "Coût moyen par unité", EN: 'Average costs per unit'},
      averageCostValue : 0,
      averageCostPerDay : [],


      statTableColumn01: {FR: "Unité", EN: 'Unit'},
      statTableColumn02: {FR: "Étiquette", EN: 'Tag'},
      statTableColumn03: {FR: "Spécifications", EN: 'Specification'},
      statTableColumn04: {FR: "Occupant", EN: 'Occupant'},
      statTableColumn05: {FR: "Coût", EN: 'Costs'},
      statTableColumn06: {FR: "Ratio selon la moyenne", EN: 'Ratio vs average'},

      chartTitle : {FR: "Coûts journalier", EN: 'Daily costs'},
      chartYlabel : {FR: "Coûts ($)", EN: 'Costs ($)'},
      buttonCloseChart : {FR: "Fermer", EN: 'Close'},
      chartLine2Label : {FR: "Coûts moyen", EN: 'Average costs'},
      chartDataSeries : [{name:'line 1',type: 'column',data:[440, 505]},
                          {name:'line 2',type: 'column',data:[440, 600]}],

      //https://apexcharts.com/javascript-chart-demos/mixed-charts/line-column/
      unitGraphOptions : {
        chart: {
        height: 350,
        type: 'line',
      },
      stroke: {
        width: [0, 4]
      },
      title: {
        text: 'Traffic Sources'
      },
      dataLabels: {
        enabled: true,
        enabledOnSeries: [0,1]
      },
      labels: ['23-10-01', '23-10-02'],
      xaxis: {
        type: 'normal'
      },
      yaxis: [{
        title: {
          text: 'Website Blog',
        },
      
      }]
      },      


    }
  },
  components: {
    Spinner,
    DatePicker,
    TimePicker,
    TimeSelect
  },
  computed: {
    ...mapState('sessionStore', ['userEmail','profileData','actualBundle','parentContainer']),
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),

   toggleDisplayBanner(){
      this.flagDisplayBanner = ~this.flagDisplayBanner
      this.getUnitTags()
      this.getSpecLists()
    },

  toggleConfigView(){
    this.flagDisplayDetail = ~this.flagDisplayDetail
  },


    getUnitTags(){

        var requestData = {'postAction':'GetUnitTags',
                          'bundleId':this.actualBundle.bundle_id,
                          'parentContainer':this.parentContainer}

        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
              //console.log(response)
            if(response.data.Code=='OK'){
                //console.log('--Tag List---')
                //console.log(response.data)
                this.tagsList = response.data.UnitTagsList
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  }
            })
    },

    getSpecLists(){
        var requestData = {'postAction':'GetUnitSpecLists',
                          'bundleId':this.actualBundle.bundle_id,
                          'parentContainer':this.parentContainer}

        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
              //console.log(response)
            if(response.data.Code=='OK'){
                console.log('--Spec List---')
                console.log(response.data)
                this.specAreaList = response.data.SpecAreaList
                this.specTypeList = response.data.SpecTypeList
                this.specYearOfConstructList = response.data.SpecYearOfConstructList
                //this.tagsList = response.data.UnitTagsList
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  }
            })
    },

    applyUnitFilter(){
      this.flagDisplayStatTable =false
      this.flagDisplayGraph =false
      this.unitsDataFiltered = []
      for (var n = 0; n < this.unitList.length; n++){
        this.unitFilterFlagList[n]=true

        if(this.selectedTag != 'All'){
          this.unitFilterFlagList[n]=false
          for(var m = 0;m<this.unitList[n].unit_tags.length;m++){
            if(this.unitList[n].unit_tags[m]==this.selectedTag){
              this.unitFilterFlagList[n]=true
            }
          }
        }

        if(this.selectedType != 'All'){
          this.unitFilterFlagList[n] = this.unitFilterFlagList[n] && (this.unitList[n].spec_type_id == this.selectedType) 
        }

        if(this.selectedArea != 'All'){
          this.unitFilterFlagList[n] = this.unitFilterFlagList[n] && (this.unitList[n].spec_area_id == this.selectedArea) 
        }

        if(this.selectedYearOfConstruction != 'All'){
          this.unitFilterFlagList[n] = this.unitFilterFlagList[n] && (this.unitList[n].spec_building_construction_year_id == this.selectedYearOfConstruction) 
        }

        if(this.unitFilterFlagList[n]){
          this.unitsDataFiltered.push(this.unitsData[n])
          this.unitsDataFiltered[this.unitsDataFiltered.length -1]['tags'] = this.selecTagNameFromID(this.unitList[n].unit_tags)
          this.unitsDataFiltered[this.unitsDataFiltered.length -1]['type'] = this.selecSpecNameFromID(this.unitList[n].spec_type_id)
          this.unitsDataFiltered[this.unitsDataFiltered.length -1]['area'] = this.selecAreaNameFromID(this.unitList[n].spec_area_id)
          this.unitsDataFiltered[this.unitsDataFiltered.length -1]['yoc'] = this.selecYocNameFromID(this.unitList[n].spec_building_construction_year_id)
        }

      }
      //console.log('================================')
      //console.log('unitsDataFiltered:')
      //console.log(this.unitsDataFiltered)


      //-------------------------------------------------
      //We compute the sum per unit of filtered unit
      //and compute the sum of all unit
      //-------------------------------------------------
      this.averageCostValue =0
      for (var m = 0; m < this.unitsDataFiltered.length; m++){
        var SumCost = 0
        if (m==0){this.averageCostPerDay = this.unitsDataFiltered[m].SumService.map((x) => x)}

        for (var i=0; i < this.unitsDataFiltered[m].SumService.length;i++){
          SumCost += this.unitsDataFiltered[m].SumService[i]
          if(m>0){ this.averageCostPerDay[i] +=this.unitsDataFiltered[m].SumService[i]}
        }
        this.unitsDataFiltered[m]['SumCost'] = parseFloat((SumCost).toFixed(2))
        this.averageCostValue += SumCost
      }

      //We divide the sum of cost per filtered unit count
      this.averageCostValue = Math.round(this.averageCostValue/m*100)/100
      for (var j = 0; j < this.unitsDataFiltered.length; j++){
        this.unitsDataFiltered[j]['CostVsAverage'] = parseFloat(((this.unitsDataFiltered[j].SumCost/this.averageCostValue)*100).toFixed(1))
      }

      //We divide each daily average sum per filtered unit count (m)
      for (var j = 0; j < this.averageCostPerDay.length; j++){
        this.averageCostPerDay[j] = parseFloat((this.averageCostPerDay[j]/m).toFixed(2))
      }
      this.flagDisplayStatTable =true
    },


    selecTagNameFromID(TagId){
      var returnArray = []
      for(var m=0;m<TagId.length;m++){
        for (var i=0; i < this.tagsList.length;i++){
          if(this.tagsList[i].tagId==TagId[m]){returnArray.push(this.tagsList[i].tagName)}
        }
      }
      return returnArray
    },


    selecSpecNameFromID(SpecId){
      var returnValue = ''
      for (var i=0; i < this.specTypeList.length;i++){
        if(this.specTypeList[i].list_id==SpecId){returnValue =this.specTypeList[i].description[this.actualLanguage]}
      }
      return returnValue 
    },
    selecAreaNameFromID(AreaId){
      var returnValue = ''
      for (var i=0; i < this.specAreaList.length;i++){
        if(this.specAreaList[i].list_id==AreaId){returnValue =this.specAreaList[i].description[this.actualLanguage]}
      }
      return returnValue 
    },
    selecYocNameFromID(YocId){
      var returnValue = ''
      for (var i=0; i < this.specYearOfConstructList.length;i++){
        if(this.specYearOfConstructList[i].list_id==YocId){returnValue =this.specYearOfConstructList[i].description[this.actualLanguage]}
      }
      return returnValue 
    },



    buildUnitListID(){
      this.unitListID = []
      for (var n = 0; n < this.unitList.length; n++){
        this.unitListID.push(this.unitList[n].unit_id)
      }
    },

    displayUnitGraph(index){
        this.flagDisplayGraph =false
        this.unitGraphOptions.title.text = this.chartTitle[this.actualLanguage].concat(" : ",this.unitsDataFiltered[index].UnitName)
        this.unitGraphOptions.yaxis[0].title.text = this.chartYlabel[this.actualLanguage]
        this.unitGraphOptions.labels = this.unitsDataFiltered[index].UnitXData

        this.chartDataSeries[0].name = this.unitsDataFiltered[index].UnitName
        this.chartDataSeries[0].data = this.unitsDataFiltered[index].SumService

        this.chartDataSeries[1].name = this.chartLine2Label[this.actualLanguage]
        this.chartDataSeries[1].data = this.averageCostPerDay
        this.$nextTick(() => {
          this.flagDisplayGraph =true
        });


        
    },

    readUnitsGraphData(){
      this.buildUnitListID()

      this.flagDisplayGraph =false
      this.flagDisplayStatTable =false
      this.flagGraphDataIsUpdating = true
      var GraphReadPostAction = 'GetMuttipleUnitsData'

      if (this.flagReadByInvoiceData){
        GraphReadPostAction = 'GetMuttipleUnitsDataFromInvoices'
      }

      var requestData = {'postAction':GraphReadPostAction,
                        'bundleId':this.actualBundle.bundle_id,
                        'unitList':this.unitListID,
                        'selectedTag':this.selectedTag,
                        'selectedType':this.selectedType,
                        'selectedArea':this.selectedArea,
                        'selectedYearOfConstruction':this.selectedYearOfConstruction,
                        'dateStart':this.visualisationDateStart,
                        'dateEnd':this.visualisationDateEnd}

      this.$store.dispatch('sessionStore/postBundle', requestData)
          .then((response) => {
            console.log(response)
          this.flagGraphDataIsUpdating = false
          if(response.data.Code=='OK'){
              this.unitsData = response.data.UnitsData
              
              for (var unit = 0; unit < this.unitsData.length; unit++){
                for (var service = 0; service < this.unitsData[unit].SumService.length; service++){
                  this.unitsData[unit].SumService[service] = parseFloat(this.unitsData[unit].SumService[service].toFixed(2))
                }
              }
              
              this.applyUnitFilter()
              }
              else{
                window.alert(response.data.PromptMessage[this.actualLanguage])
                }
          })

    },

    },

  mounted() {
    //this.getDeviceData()
    //window.location.reload()

    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

    var thisDayUnix = (Math.floor(moment().unix()/(24*3600)))*(24*3600)
    this.visualisationDateStart =((thisDayUnix-7*24*3600) * 1000)
    this.visualisationDateEnd = (thisDayUnix * 1000)

    this.unitFilterFlagList = []
    for (var n = 0; n < this.unitList.length; n++){
      this.unitFilterFlagList.push(true)
    }
    

  }
}
</script>





// WEBPACK FOOTER //
// UnitDisplayStats.vue?38245651